import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, interval, map, startWith } from 'rxjs';
import { intersection } from 'lodash-es';
import { getDagdeel, getBegroeting } from '@cumlaude/shared-utils';
import { RRol } from '@cumlaude/service-contract';
import { UserService, rolOrder } from '../services/user.service';
import { QueryParamStateService } from '../services/query-param-state.service';
import { FilterService } from '../services/filter.service';
import { PasfotoComponent } from '../shared/components/pasfoto/pasfoto.component';
import { RolSwitcherComponent } from './rol-switcher/rol-switcher.component';
import { RecentBekekenComponent } from './recent-bekeken/recent-bekeken.component';
import { BerichtenComponent } from './berichten/berichten.component';
import { FavorietenListComponent } from '../favorieten-list/favorieten-list.component';
import { AiAssistentComponent } from './ai-assistent/ai-assistent.component';
import { NavigatieVoorkeurService } from '../services/navigatie-voorkeur.service';

@Component({
	selector: 'app-startpagina',
	templateUrl: './startpagina.component.html',
	styleUrls: ['./startpagina.component.scss'],
	imports: [PasfotoComponent, RolSwitcherComponent, RecentBekekenComponent, BerichtenComponent, FavorietenListComponent, AiAssistentComponent],
})
export class StartpaginaComponent {
	protected readonly userService = inject(UserService);
	protected readonly navigatieVoorkeurService = inject(NavigatieVoorkeurService);
	private readonly qp = inject(QueryParamStateService);
	private readonly filterService = inject(FilterService);

	private readonly dagdeel = toSignal(
		interval(60_000).pipe(
			startWith(0),
			map(() => getDagdeel(new Date())),
			distinctUntilChanged()
		),
		{ requireSync: true }
	);

	protected readonly begroeting = computed(() => getBegroeting(this.dagdeel()));

	protected readonly afkorting = computed(() => this.userService.account()?.afkorting);

	protected readonly activeRol = this.userService.activeRol;

	protected readonly subtitel = computed(() => {
		const rol = this.activeRol();
		const account = this.userService.account();
		if (!rol || !account) return '';
		return this.userService.getAccountRolDescription(rol, account);
	});

	protected readonly rollen = computed(() => intersection(rolOrder, this.userService.rollen() ?? []));

	changeRol(rol: RRol) {
		this.userService.changeRol(rol);
		this.qp.resetQueryParams().then(() => this.filterService.clearActiveNonDefault());
	}
}
